/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const fixedDigit: (num: number, digit: number) => number = (num, digit) => {
  return Math.round(num * Math.pow(10, digit)) / Math.pow(10, digit);
};
